import { useQuery } from "@apollo/client";
import { BaseTable, IBaseTableProps } from "@sede-x/shell-ds-react-framework";
import { getPaginationRowModel } from "@tanstack/react-table";
import dayjs from "dayjs";
import { loader } from "graphql.macro";
import { useState } from "react";
import { ApolloErrorViewer } from "shared/components/ApolloErrorViewer";
import LoadingPanel from "shared/components/LoadingPanel";
import { GqlResponse, TMovementDeliveryEvent } from "ticketing/ticketing.types";

type Response = GqlResponse<TMovementDeliveryEvent[], "deliveryEventsOfMovementAtRevision">;
const GET_DELIVERY_EVENTS_REVISIONS_OF_MOVEMENT = loader(
  "../../ticketing-graphql/deliveryEventsOfMovementAtRevision.graphql"
);

const transformData = (deliveryEvents: TMovementDeliveryEvent[]) => {
  return deliveryEvents?.map(d => ({
    ...d,
    deliveryEventDate: new Date(d.deliveryEventDate)
  }));
};

type RevisionsMovementDeliveryEventsProps = {
  movementId: string;
  revisionNumber: string;
};

const columns: IBaseTableProps<TMovementDeliveryEvent>["columns"] = [
  {
    header: "Event",
    accessorKey: "deliveryEventType.name",
    size: 140 // Converted width to size
  },
  {
    header: "Event Date",
    accessorKey: "deliveryEventDate",
    size: 200, // Converted width to size
    cell: ({ row }) => dayjs(row.original.deliveryEventDate).format("MM/DD/YY") // Format the date
  },
  {
    header: "Status",
    accessorKey: "deliveryEventStatus",
    size: 140 // Converted width to size
  }
];

/**
 *
 * @param param0
 * @returns
 */
const RevisionsMovementDeliveryEvents = ({
  movementId,
  revisionNumber
}: RevisionsMovementDeliveryEventsProps) => {
  const { loading, error } = useQuery<Response>(GET_DELIVERY_EVENTS_REVISIONS_OF_MOVEMENT, {
    fetchPolicy: "no-cache",
    variables: { movementId, revisionNumber },
    onCompleted: data =>
      setDeliveryEvents(transformData(data.deliveryEventsOfMovementAtRevision))
  });

  const [deliveryEvents, setDeliveryEvents] = useState<TMovementDeliveryEvent[]>();

  return (
    <>
      {loading && <LoadingPanel />}
      {error && <ApolloErrorViewer error={error} />}

     
        <BaseTable
          data={deliveryEvents}
          columns={columns}
          tableOptions={{
            defaultColumn: {
              minSize: 100,
              maxSize: 400
            },
            enableColumnResizing: true,
            columnResizeMode: "onChange",
            getPaginationRowModel: getPaginationRowModel()
          }}
          style={{width: "100%",  tableLayout: "fixed"}}
        />
     
    </>
  );
};

export default RevisionsMovementDeliveryEvents;
